/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiEmailDtoCommunicationEventDto } from './WebApiEmailDtoCommunicationEventDto';
import {
    WebApiEmailDtoCommunicationEventDtoFromJSON,
    WebApiEmailDtoCommunicationEventDtoFromJSONTyped,
    WebApiEmailDtoCommunicationEventDtoToJSON,
} from './WebApiEmailDtoCommunicationEventDto';

/**
 * 
 * @export
 * @interface WebApiEmailDtoCommunicationReportDto
 */
export interface WebApiEmailDtoCommunicationReportDto {
    /**
     * 
     * @type {WebApiEmailDtoCommunicationEventDto}
     * @memberof WebApiEmailDtoCommunicationReportDto
     */
    event?: WebApiEmailDtoCommunicationEventDto;
    /**
     * 
     * @type {Array<WebApiEmailDtoCommunicationEventDto>}
     * @memberof WebApiEmailDtoCommunicationReportDto
     */
    subEvents?: Array<WebApiEmailDtoCommunicationEventDto> | null;
}

/**
 * Check if a given object implements the WebApiEmailDtoCommunicationReportDto interface.
 */
export function instanceOfWebApiEmailDtoCommunicationReportDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiEmailDtoCommunicationReportDtoFromJSON(json: any): WebApiEmailDtoCommunicationReportDto {
    return WebApiEmailDtoCommunicationReportDtoFromJSONTyped(json, false);
}

export function WebApiEmailDtoCommunicationReportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiEmailDtoCommunicationReportDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'event': !exists(json, 'event') ? undefined : WebApiEmailDtoCommunicationEventDtoFromJSON(json['event']),
        'subEvents': !exists(json, 'subEvents') ? undefined : (json['subEvents'] === null ? null : (json['subEvents'] as Array<any>).map(WebApiEmailDtoCommunicationEventDtoFromJSON)),
    };
}

export function WebApiEmailDtoCommunicationReportDtoToJSON(value?: WebApiEmailDtoCommunicationReportDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'event': WebApiEmailDtoCommunicationEventDtoToJSON(value.event),
        'subEvents': value.subEvents === undefined ? undefined : (value.subEvents === null ? null : (value.subEvents as Array<any>).map(WebApiEmailDtoCommunicationEventDtoToJSON)),
    };
}

